import React, { useEffect } from "react";
import { FiX } from "react-icons/fi";

export default function TrombinoLightbox({ preview, onClose }) {
  useEffect(() => {
    if (!preview) return;

    const onKeyDown = (event) => {
      if (event.key === "Escape") onClose?.();
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [onClose, preview]);

  if (!preview?.src) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/85 p-4 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-3xl"
        onClick={(event) => event.stopPropagation()}
      >
        <button
          type="button"
          onClick={onClose}
          className="absolute -right-2 -top-2 z-20 inline-flex h-10 w-10 items-center justify-center rounded-full bg-white text-slate-950 shadow-lg transition hover:bg-slate-100"
          aria-label="Fermer"
        >
          <FiX className="h-5 w-5" />
        </button>

        <div className="overflow-hidden rounded-[2rem] bg-slate-950 shadow-2xl">
          <img
            src={preview.src}
            alt={preview.alt}
            className="max-h-[80vh] w-full object-contain"
          />
        </div>

        <div className="mt-4 text-center text-white">
          <p className="text-xl font-bold">{preview.alt}</p>
          {preview.subtitle && (
            <p className="mt-1 text-sm font-semibold text-white/70">
              {preview.subtitle}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}